import {
  enableProdMode,
  provideAppInitializer,
  inject,
  ErrorHandler,
  importProvidersFrom,
} from '@angular/core';

import { environment } from './environments/environment';
import { initSentry } from './sentry.config';
import { providePrimeNG } from 'primeng/config';
import { CustomPrimeTheme } from '@ui/global-shared/util/primeng-theme';
import { MessageService, ConfirmationService } from 'primeng/api';
import { CsrfInitializerService } from '@ui/global-shared/services/csrf/csrf-initializer.service';
import { Observable } from 'rxjs';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { GlobalSharedModule } from '@ui/global-shared';
import { MessageModule } from 'primeng/message';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import localeDeAt from '@angular/common/locales/de-AT';
import { registerLocaleData } from '@angular/common';

function initializeCsrf(svc: CsrfInitializerService): () => Observable<void> {
  return () => svc.initializeCsrf();
}

if (environment.production) {
  enableProdMode();
}

initSentry();
registerLocaleData(localeDeAt);

bootstrapApplication(AppComponent, {
  providers: [
    provideNoopAnimations(),
    importProvidersFrom(AppRoutingModule, GlobalSharedModule, MessageModule),
    providePrimeNG({
      theme: {
        preset: CustomPrimeTheme,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    MessageService,
    ConfirmationService,
    provideAppInitializer(() => {
      // Ensures that a CSRF token cookie is obtained from the backend on application startup.
      // Without a CSRF token up-front, the first request to an endpoint
      // that requires CSRF protection (e.g. login) will fail.
      const initializerFn = initializeCsrf(inject(CsrfInitializerService));
      return initializerFn();
    }),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ],
}).catch((err) => console.error(err));
